import axios from '@axios';

export default class SisModuloClient {
  async obterMatriz() {
    return axios.get('/modulos/matriz');
  }

  async syncManifest(itens) {
    return axios.post('/modulos/sync', { itens });
  }

  async atualizarPerfilPermissoes(perfilId, permissaoIds) {
    return axios.put(`/modulos/perfil/${perfilId}`, { permissaoIds });
  }
}
